const dddvalidos = [11,12,13,14,15,16,17,18,19,21,22,24,27,28,31,32,33,34,35,37,38,41,42,43,44,45,46,47,48,49,51,53,54,55,61,62,63,64,65,66,67,68,69,71,73,74,75,77,79,81,82,83,84,85,86,87,88,89,91,92,93,94,95,96,97,98,99]

function descifrarFixoOrCelular($telefone)
{
    let $ddd    = $telefone.substr(0, 2)
    let $digito = $telefone.substr(2, 1)

    if( $digito >= 2 && $digito <= 4 )
        return false
    else {
        $telefone = $ddd + "9" + $telefone.substr(2, $telefone.length )
        return validaCelular($telefone)
    }
}

function validaCelular($telefone)
{
    if ($telefone.substr(0, 1) == 0)
        $telefone = $telefone.substr(1, $telefone.length)

    let $ddd = $telefone.substr(0, 2)
    if( !dddvalidos.includes( +$ddd ) )
    {
        return false
    }
    let $digito = $telefone.substr(2, 1)



    if( ($ddd == 11 && $digito < 5 || $digito > 9) || ( $ddd != 11 && $digito < 7 || $digito > 9 ) )
    {
        return false
    }

    return $telefone
}

function validaNumber($telefones)
{

    for(let i in $telefones)
    {
        if(!$telefones[i]) return false
        $telefones[i] = $telefones[i].replace(/\D/g, "")
        $telefones[i] = $telefones[i].replace(/(.)\1{4,}/, '$1')
        if(!$telefones[i]) return false

        if ($telefones[i].substr(0, 1) == 0)
            $telefones[i] = $telefones[i].substr(1, $telefones[i].length )

        if( $telefones[i].length > 11 && $telefones[i].substr(2, 1) == 0)
            $telefones[i] = $telefones[i].substr(0,2) + $telefones[i].substr(3, $telefones[i].length )

        if( $telefones[i].length < 10 )
        {
            return false
        }

        switch( $telefones[i].length )
        {
            case 10:
                return descifrarFixoOrCelular($telefones[i])
            break

            case 11:
                return validaCelular($telefones[i])
            break

            case 12:
                $telefones[i] = $telefones[i].substr(2, $telefones[i].length)
                return descifrarFixoOrCelular($telefones[i])
            break

            case 13:
                $telefones[i] = $telefones[i].substr(2, $telefones[i].length)
                return validaCelular($telefones[i])
            break

            default:
                return false
            break
        }
    }
}

export default validaNumber



// WEBPACK FOOTER //
// ./src/helpers/validaNumber.js